import commonConfig from "./common";
import englishLang from './english';

let developmentConfig = {
  ...commonConfig,
  langLabels: englishLang
}

export default developmentConfig;